import { Avatar, HStack, Icon, SuitabilityBadge, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { InfoPanelTypes } from '..';
import { CustomerWalletPoints } from '../../../../../../components/CustomerWalletPoints';
import { MultipleAccountsSelection } from '../../../../../../components/MultipleAccountsSelection';
import { CustomerDuckCopyIcon } from '../../../Account/components/InfoContainer/components/CustomerDuckCopyIcon';
import { BlockStatusTooltip } from '../components/BlockStatusTooltip';

export const InfoPanelVisibleDesktop: React.FC<InfoPanelTypes.Props> = ({
  isLoading,
  customer,
  accountSelected,
  handleChangeAccount,
}) => {
  return (
    <HStack space="stack.xxxs" width="full" alignItems="center">
      <HStack space="stack.nano" width="20%">
        {!isLoading && customer ? (
          <SuitabilityBadge
            label={customer.investorProfile.suitabilityNormalized}
            hideText
            withTooltip
          />
        ) : (
          <Avatar
            testId="avatar"
            isLoading
            bgColor="backgroundlight"
            initials="LO"
            textColor="background"
          />
        )}
        <VStack space="stack.quarck" flex={1}>
          <Text
            isLoading={isLoading}
            variant="semibold"
            flex={1}
            ellipsizeMode="tail"
            numberOfLines={1}
            color="neutral.darkest">
            {customer?.personalInformation.fullNameNormalized}
          </Text>
          <HStack space="inline.quarck" alignItems="center" flex={1}>
            <Text
              isLoading={isLoading}
              color="neutral.medium"
              variant="semibold"
              fontSize="xs"
              lineBreakMode="tail"
              numberOfLines={3}>
              {customer?.personalInformation.emailNormalized}
            </Text>
            {!!customer?.personalInformation.emailNormalized && !isLoading && (
              <CustomerDuckCopyIcon valueToCopy={customer.personalInformation.emailNormalized} />
            )}
          </HStack>
        </VStack>
      </HStack>
      <HStack flex={1} space="stack.nano">
        <VStack space="stack.quarck" flex={1}>
          <Text variant="semibold">Conta de custódia</Text>
          {customer && !isLoading ? (
            <MultipleAccountsSelection
              accounts={customer.additionalAccounts}
              accountSelected={accountSelected}
              setAccountSelected={handleChangeAccount}
            />
          ) : (
            <Text isLoading flex={1} />
          )}
        </VStack>
        <VStack space="stack.quarck" flex={1.2}>
          <Text variant="semibold">Pts da carteira</Text>
          {!isLoading && customer ? (
            <CustomerWalletPoints
              preventPadding
              accountNumber={customer.additionalAccounts[0]?.accountNumber}
            />
          ) : (
            <Text isLoading={isLoading} />
          )}
        </VStack>
        <VStack space="stack.quarck" flex={0.9}>
          <Text variant="semibold">Cadastro</Text>
          <BlockStatusTooltip customer={customer} isLoading={isLoading}>
            <HStack alignItems="center" space="stack.quarck">
              <Text isLoading={isLoading}>
                {customer?.accountAndEarnings.statusNormalized.textNormalized}
              </Text>
              {!isLoading && customer && (
                <Icon
                  testID="account-status-icon"
                  name={customer?.accountAndEarnings.statusNormalized.iconNormalized}
                  size={customer?.accountAndEarnings.statusNormalized.iconSizeNormalized}
                  color={customer?.accountAndEarnings.statusNormalized.iconColorNormalized}
                />
              )}
            </HStack>
          </BlockStatusTooltip>
        </VStack>
        <VStack space="stack.quarck" flex={1}>
          <HStack alignItems="center" space="stack.nano">
            <Text variant="semibold">Disp. para investir</Text>
          </HStack>
          <Text isLoading={isLoading}>
            {Utils.Mask.Money(customer?.accountAndEarnings.availableToInvest)}
          </Text>
        </VStack>
        <VStack space="stack.quarck" flex={1}>
          <HStack alignItems="center" space="stack.nano">
            <Text variant="semibold">Patrimônio total</Text>
          </HStack>
          <Text isLoading={isLoading}>{customer?.accountAndEarnings.totalNetWorthNormalized}</Text>
        </VStack>
        <VStack space="stack.quarck" flex={1}>
          <HStack alignItems="center" space="stack.nano">
            <Text variant="semibold">Saldo em conta</Text>
          </HStack>
          <Text isLoading={isLoading}>
            {Utils.Mask.Money(customer?.accountAndEarnings.availableBalance)}
          </Text>
        </VStack>
      </HStack>
    </HStack>
  );
};
